import {FC} from "react";
import {styled} from "@mui/material/styles";
import {t} from "../../../styles/theme/tokens";
import {SIDEBAR_HEADER_HEIGHT} from "./constants";

/**
 * Logo — шапка sidebar'a.
 *
 * Фиксированная высота SIDEBAR_HEADER_HEIGHT (56px), совпадает с высотой
 * мобильного AppNavbar — это даёт визуальное равновесие на десктопе и
 * предсказуемость на мобильном.
 *
 * letter-spacing 8px — сильный, но не разваливающий буквы интервал. Старые
 * 13px на семи буквах съедали половину ширины sidebar'a и буквы реально
 * разъезжались. 8px даёт характер ("это не Inter") но текст остаётся
 * читаемым словом.
 *
 * Шрифт — Courier Prime (моноширинный), как и было. Это сильная находка
 * брендинга, не трогаем.
 */

const LogoRoot = styled("div")({
    height: SIDEBAR_HEADER_HEIGHT,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingInline: 16,
    flexShrink: 0,
    borderBottom: `1px solid ${t.divider}`,
});

/**
 * styled('h1') вместо styled(Typography) — намеренно.
 *
 * Здесь нам не нужны ни varianты, ни gutterBottom, ни paragraph из Typography.
 * А `styled(Typography)` в MUI v6+ теряет polymorphic-типизацию `component`
 * prop — известное ограничение (Typography — OverridableComponent, обёрткой
 * styled оно "схлопывается" до базового тега 'span').
 *
 * styled('h1') решает обе задачи: семантический <h1> в DOM и чистая
 * типизация без хаков.
 */
const LogoText = styled("h1")({
    fontFamily: '"Courier Prime", "JetBrains Mono", monospace',
    fontSize: "1.25rem",               // 20px
    fontWeight: 700,
    letterSpacing: "0.5em",            // даёт характерный "технический" trackings
    lineHeight: 1,
    color: t.text.primary,
    margin: 0,                         // <h1> имеет дефолтный margin — сбрасываем
    // Компенсируем letter-spacing справа: tracking добавляет пустоту после
    // последней буквы, и текст выглядит сдвинутым влево.
    paddingLeft: "0.5em",
    userSelect: "none",
});

const Logo: FC = () => {
    return (
        <LogoRoot>
            <LogoText>atom eol</LogoText>
        </LogoRoot>
    );
};

export default Logo;